import React from "react";
import Transport from "../inc/Transport";
import Operation from "../inc/Operation";
import WhatsApp  from "../inc/Whatsapp";
import {
  FaUser, FaHeadset, FaLifeRing, FaCrown,
  FaDatabase, FaProjectDiagram, FaCloud, FaBug, FaLock,
  FaServer, FaNetworkWired, FaMobileAlt, FaShieldAlt,
  FaVideo, FaPhoneAlt, FaChalkboardTeacher, FaTools,
} from "react-icons/fa";
import teamImage    from "../images/whyus.jpg";
import BannerImg    from "../images/service.jpg";
import ClientsIcon  from "../images/d10.png";
import ResultsIcon  from "../images/d9.jpg";
import SecurityIcon from "../images/d7.png";
import SupportIcon  from "../images/d8.avif";

/* ─────────────────────────────────────────────────────────────
   Brand constant
───────────────────────────────────────────────────────────── */
const COMPANY = "Skywise Technologies";

/* ─────────────────────────────────────────────────────────────
   Data
───────────────────────────────────────────────────────────── */
const WHY_US_PILLARS = [
  { id: "w1", icon: FaUser,     title: "People",           desc: "We understand that our people impact the success of our business, and we hire people who are dedicated and effective." },
  { id: "w2", icon: FaHeadset,  title: "Customer Service", desc: "We strive to provide superior customer service and ensure that every client receives the deserved value." },
  { id: "w3", icon: FaLifeRing, title: "Support",          desc: "Our Engineers are equipped, trained and usually go the extra mile to ensure business productivity." },
  { id: "w4", icon: FaCrown,    title: "Quality",          desc: "We are committed to deliver outstanding, cutting edge IT solutions that add real value beyond what is expected." },
];

const APP_SOLUTIONS = [
  { id: "as1", icon: FaDatabase,       title: "Oracle Stack",          desc: "Database, Middleware, Cloud, Analytics or Hardware — we help you maintain the entire spectrum through its entire life cycle." },
  { id: "as2", icon: FaProjectDiagram, title: "BPM & Automation",      desc: "Automating processes through mobile applications and integrating with legacy systems in the shortest possible time." },
  { id: "as3", icon: FaCloud,          title: "Cloud & Digitalization", desc: "Cloud is more of a tool than a product. We help you use it for business cases most suitable for cloud." },
  { id: "as4", icon: FaBug,            title: "Software Testing",       desc: "From testing & training to consulting & deployment, we bring a diligent QA approach to your complex testing environment." },
  { id: "as5", icon: FaLock,           title: "Data Protection",        desc: "On cloud or on-premise, data is key to business decisions. We ensure you choose the right solution for your critical data." },
  { id: "as6", icon: FaServer,         title: "Virtualization",         desc: "IT landscape is spread over cloud, premise, or hybrid. Our virtualization offerings ensure optimal hardware usage." },
];

const APP_BENEFITS = [
  { id: "ab1", title: "Strong Domain Expertise",   desc: "Every requirement is unique. With expertise across decades and multiple technologies, we bring the best suitable solution." },
  { id: "ab2", title: "Simplicity in Complexity",  desc: "Problems are complex, dynamic and business-specific. We simplify requirements and provide executable solutions." },
  { id: "ab3", title: "Controlled Cost",           desc: "We ensure our solutions fit your budget and business requirements while maximizing ROI." },
  { id: "ab4", title: "Strong Academia",           desc: "We partner with top institutions in India to bring the best brains at your service." },
  { id: "ab5", title: "Your Growth is Our Growth", desc: "If you achieve your objective, we achieve ours too — this is the ethos of every engagement." },
];

const NET_SOLUTIONS = [
  { id: "ns1", icon: FaNetworkWired,      title: "Networking",                   desc: "Performance and security is what today's cloud-based applications require. We present solutions which always keep your network ON." },
  { id: "ns2", icon: FaMobileAlt,         title: "Wireless & Mobility",          desc: "Be it SoHo or large-scale enterprise, flexibility and agility is the demand. Our enriching experience delivers when you need it." },
  { id: "ns3", icon: FaShieldAlt,         title: "Network Security",             desc: "There is always a better and budget-friendly way to optimally secure a network. We facilitate what your IT landscape demands." },
  { id: "ns4", icon: FaVideo,             title: "Conferencing & Collaboration", desc: "4K is the demand and AV over IP is the technology. With advanced software, experience services and cloud technology." },
  { id: "ns5", icon: FaPhoneAlt,          title: "Voice over IP",                desc: "By adding voice on IP along with data, we bring budget-friendly, scalable technology to your company's advantage." },
  { id: "ns6", icon: FaChalkboardTeacher, title: "Boardroom Solutions",          desc: "Interactive, collaborative and 4K-ready boardroom solutions enabling productive and result-oriented meetings." },
];

const NET_BENEFITS = [
  { id: "nb1", title: "Strong Domain Expertise",   desc: "Every requirement is different and unique. With strong domain expertise spread across OEMs, we bring the best solution." },
  { id: "nb2", title: "Simplicity in Complexity",  desc: "Problems are usually complex, dynamic and business-specific. We simplify and provide an easy, executable solution." },
  { id: "nb3", title: "Controlled Cost",           desc: "Positive ROI is paramount. We ensure solutions fit the budget and meet your business requirements." },
  { id: "nb4", title: "Strong Academia",           desc: "We partner with the best institutions in India to bring the best brains at your service." },
  { id: "nb5", title: "Your Growth is Our Growth", desc: "If you achieve your objective, we achieve ours too — that is the ethos we carry in every engagement." },
];

const SYS_SOLUTIONS = [
  { id: "ss1", icon: FaServer,    title: "Servers & Compute",                desc: "From leading-edge hyper-converged systems to specialized HPC, we help you decide the best mix of infrastructure." },
  { id: "ss2", icon: FaDatabase,  title: "Storages",                         desc: "Automating processes through business-friendly mobile applications and integrating with legacy systems efficiently." },
  { id: "ss3", icon: FaCloud,     title: "Datacenter & Disaster Recovery",   desc: "Cloud is more of a tool than a product. We help you use tools for business cases most suitable for cloud." },
  { id: "ss4", icon: FaMobileAlt, title: "Mobility",                         desc: "From basics to entire life cycle management of mobile devices, we ensure your devices work safely and securely." },
  { id: "ss5", icon: FaVideo,     title: "Physical Security & Surveillance", desc: "Spectrum of security services including design, implementation and post-deployment support across technologies." },
  { id: "ss6", icon: FaTools,     title: "Support & Maintenance Services",   desc: "Comprehensive IT support services for hardware repair, maintenance and uptime across all major OEMs and devices." },
];

const SYS_BENEFITS = [
  { id: "syb1", title: "RiMs",                    desc: "Remote infrastructure management services including health management and troubleshooting across all major OEMs." },
  { id: "syb2", title: "End of Life Support",      desc: "Support and uptime services for all end-of-life devices from all major OEMs across India, including spares and services." },
  { id: "syb3", title: "Simplicity in Complexity", desc: "Problems are complex and business-specific. We simplify them and deliver easy, executable solutions." },
  { id: "syb4", title: "Controlled Cost",          desc: "In difficult times, ROI is paramount. Our support services are cost-effective and budget-friendly." },
  { id: "syb5", title: "IT FMS",                   desc: "Onsite support for critical software, hardware, and datacenter operations, whether on-premise or colocated." },
];

const CHOOSE_US = [
  { id: "cu1", icon: ClientsIcon,  alt: "Team celebrating a successful client outcome", title: "Delighting Clients", desc: "We exceed expectations with tailored digital solutions that align with your vision."  },
  { id: "cu2", icon: ResultsIcon,  alt: "Dashboard showing positive business results",  title: "Result-Driven",     desc: "We prioritize measurable impact and sustainable growth for every client."               },
  { id: "cu3", icon: SecurityIcon, alt: "Secure data protection shield illustration",   title: "Data Security",     desc: "Advanced security protocols safeguard your data and ensure compliance."                 },
  { id: "cu4", icon: SupportIcon,  alt: "Support agent assisting a client remotely",    title: "24/7 Support",      desc: "Round-the-clock assistance to keep your business running smoothly."                    },
];

/* ─────────────────────────────────────────────────────────────
   Reusable SolutionSection
───────────────────────────────────────────────────────────── */
function SolutionSection({ eyebrow, title, solutions, benefits, alignStart = false }) {
  return (
    <>
      {/* Dark solutions block */}
      <div className="sv-dark-block">
        <div className="sv-container">
          <span className="sv-eyebrow">{eyebrow}</span>
          <h3 className="sv-block-title">{title}</h3>
          <div className={`sv-sol-grid${alignStart ? " sv-sol-grid--start" : ""}`}>
            {solutions.map(({ id, icon: Icon, title: t, desc }) => (
              <div key={id} className={`sv-sol-item${alignStart ? " sv-sol-item--row" : ""}`}>
                {alignStart ? (
                  <>
                    <Icon size={28} className="sv-sol-icon-inline" aria-hidden="true" />
                    <div>
                      <h6 className="sv-sol-item-title">{t}</h6>
                      <p className="sv-sol-item-desc">{desc}</p>
                    </div>
                  </>
                ) : (
                  <>
                    <Icon size={32} className="sv-sol-icon-center" aria-hidden="true" />
                    <h6 className="sv-sol-item-title">{t}</h6>
                    <p className="sv-sol-item-desc">{desc}</p>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* White benefits block */}
      <div className="sv-light-block">
        <div className="sv-container">
          <span className="sv-eyebrow sv-eyebrow--blue">Benefits</span>
          <h3 className="sv-block-title sv-block-title--dark">
            Our services provide a unique range of benefits
          </h3>
          <div className="sv-ben-grid">
            {benefits.map(({ id, title: t, desc }) => (
              <div key={id} className="sv-benefit">
                <div className="sv-benefit-bar" aria-hidden="true" />
                <h6 className="sv-benefit-title">{t}</h6>
                <p className="sv-benefit-desc">{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

/* ─────────────────────────────────────────────────────────────
   Main Component
───────────────────────────────────────────────────────────── */
function Service() {
  return (
    <>
      <style>{`
        *, *::before, *::after { box-sizing: border-box; }

        .sv-page {
          width: 100%;
          max-width: 100vw;
          overflow-x: hidden;
          background: #f9f9f9;

          /* ── Palette ── */
          --sv-primary:   #0b355e;
          --sv-accent:    #007bff;
          --sv-danger:    #ef4444;
          --sv-dark-bg:   #0b0d29;
          --sv-text-body: #374151;
          --sv-text-muted:#9ca3af;

          /*
           * System font stack — no external download.
           * Both display and body use the same stack for
           * a clean, unified, professional feel.
           *
           *   macOS / iOS  → San Francisco
           *   Windows      → Segoe UI
           *   Android      → Roboto
           *   Fallback     → Helvetica → Arial → sans-serif
           */
          --font-display: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
          --font-body:    -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;

          font-family: var(--font-body);
        }

        /* ── Layout ── */
        .sv-container {
          width: 100%;
          max-width: 1180px;
          margin: 0 auto;
          padding: 0 1.5rem;
        }

        /* ── Hero ── */
        .sv-hero {
          width: 100%;
          height: 380px;
          background-size: cover;
          background-position: center;
          position: relative;
        }
        .sv-hero-overlay {
          position: absolute; inset: 0;
          background: rgba(0,0,0,0.6);
          display: flex; flex-direction: column;
          justify-content: center; align-items: center;
          text-align: center; color: #fff;
          padding: 0 1rem;
        }
        .sv-hero-overlay h1 {
          font-family: var(--font-display);
          font-size: clamp(1.8rem, 5vw, 3rem);
          font-weight: 600;
          margin: 0 0 0.75rem;
          line-height: 1.3;
        }
        .sv-hero-overlay p {
          font-family: var(--font-body);
          font-size: clamp(0.95rem, 2vw, 1.1rem);
          font-weight: 400;
          max-width: 650px;
          color: rgba(255,255,255,0.85);
          margin: 0;
          line-height: 1.7;
        }

        /* ── Why Us ── */
        .sv-why-section { padding: 4rem 0; }
        .sv-why-split {
          display: flex; flex-wrap: wrap;
          align-items: center; gap: 2.5rem;
          margin-bottom: 3rem;
        }
        .sv-why-img { flex: 1 1 280px; }
        .sv-why-img img {
          width: 100%; max-width: 100%;
          height: auto; max-height: 350px;
          object-fit: cover; border-radius: 12px;
        }
        .sv-why-text { flex: 1 1 280px; }
        .sv-why-text h3 {
          font-family: var(--font-display);
          font-size: 1.5rem;
          font-weight: 600;
          color: var(--sv-primary);
          margin-bottom: 1rem;
          line-height: 1.3;
        }
        .sv-why-text p {
          font-family: var(--font-body);
          color: var(--sv-text-body);
          font-size: 15px;
          font-weight: 400;
          line-height: 1.8;
          margin: 0;
        }

        /* Why Us pillars */
        .sv-pillars-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 1.5rem;
          text-align: center;
        }
        .sv-pillar h6 {
          font-family: var(--font-display);
          font-weight: 600;
          font-size: 0.95rem;
          color: var(--sv-primary);
          margin: 0.75rem 0 0.4rem;
          line-height: 1.3;
        }
        .sv-pillar p {
          font-family: var(--font-body);
          font-size: 14px;
          font-weight: 400;
          color: var(--sv-text-body);
          margin: 0;
          line-height: 1.65;
        }

        /* ── What We Offer intro ── */
        .sv-offer-intro {
          text-align: center;
          padding: 3rem 1.5rem 1rem;
        }
        .sv-offer-intro h2 {
          font-family: var(--font-display);
          font-size: clamp(1.4rem, 3vw, 1.9rem);
          font-weight: 600;
          color: #1a1a2e;
          margin-bottom: 0.5rem;
          line-height: 1.3;
        }
        .sv-offer-intro hr {
          border: none;
          border-top: 3px solid var(--sv-accent);
          width: 80px;
          margin: 0.75rem auto 1rem;
        }
        .sv-offer-intro p {
          font-family: var(--font-body);
          font-size: 1rem;
          font-weight: 400;
          color: #6b7280;
          max-width: 750px;
          margin: 0 auto;
          line-height: 1.75;
        }

        /* ── Shared section blocks ── */
        .sv-dark-block  { width: 100%; background: var(--sv-dark-bg); padding: 4rem 0; }
        .sv-light-block { width: 100%; background: #fff; padding: 4rem 0; }

        .sv-eyebrow {
          display: block;
          font-family: var(--font-body);
          font-size: 0.72rem;
          font-weight: 700;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: #3b82f6;
          margin-bottom: 0.5rem;
          text-align: center;
        }
        .sv-eyebrow--blue { color: var(--sv-accent); }

        .sv-block-title {
          font-family: var(--font-display);
          font-size: clamp(1.2rem, 2.5vw, 1.6rem);
          font-weight: 600;
          color: #fff;
          text-align: center;
          margin: 0 0 2.5rem;
          line-height: 1.35;
        }
        .sv-block-title--dark { color: #1a1a2e; }

        /* Solutions grid */
        .sv-sol-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 1.75rem;
          text-align: center;
          color: #fff;
        }
        .sv-sol-grid--start { text-align: left; }

        .sv-sol-item-title {
          font-family: var(--font-display);
          font-weight: 600;
          font-size: 0.95rem;
          margin: 0.6rem 0 0.4rem;
          line-height: 1.3;
        }
        .sv-sol-item-desc {
          font-family: var(--font-body);
          font-size: 13px;
          font-weight: 400;
          color: var(--sv-text-muted);
          margin: 0;
          line-height: 1.65;
        }
        .sv-sol-icon-center { color: #fff; margin-bottom: 0.5rem; }

        .sv-sol-item--row {
          display: flex;
          align-items: flex-start;
          gap: 1rem;
          text-align: left;
        }
        .sv-sol-icon-inline { color: #3b82f6; flex-shrink: 0; margin-top: 3px; }

        /* Benefits grid */
        .sv-ben-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 1.5rem;
        }
        .sv-benefit { padding-top: 0.75rem; }
        .sv-benefit-bar {
          height: 3px; width: 40px;
          background: var(--sv-danger);
          margin-bottom: 0.75rem;
        }
        .sv-benefit-title {
          font-family: var(--font-display);
          font-weight: 600;
          font-size: 0.9rem;
          color: var(--sv-primary);
          margin-bottom: 0.4rem;
          line-height: 1.3;
        }
        .sv-benefit-desc {
          font-family: var(--font-body);
          font-size: 13px;
          font-weight: 400;
          color: var(--sv-text-body);
          line-height: 1.65;
          margin: 0;
        }

        /* ── Operation wrapper ── */
        .sv-operation-wrap {
          width: 100%;
          max-width: 1180px;
          margin: 3rem auto;
          padding: 3rem 2rem;
          background: #fff;
          border-radius: 20px;
          box-shadow: 0 8px 25px rgba(0,0,0,0.08);
        }

        /* ── Choose Us ── */
        .sv-choose-section {
          width: 100%;
          padding: 4rem 0;
          background: #f3f4f6;
        }
        .sv-choose-title {
          font-family: var(--font-display);
          font-size: clamp(1.3rem, 3vw, 1.8rem);
          font-weight: 600;
          color: #1a1a2e;
          text-align: center;
          margin-bottom: 2rem;
          line-height: 1.3;
        }
        .sv-choose-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 1.25rem;
        }
        .sv-choose-card {
          background: #fff;
          border-radius: 12px;
          padding: 2rem 1.25rem;
          text-align: center;
          box-shadow: 0 4px 16px rgba(0,0,0,0.07);
          transition: transform 0.25s, box-shadow 0.25s;
        }
        .sv-choose-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 28px rgba(0,0,0,0.12);
        }
        .sv-choose-card img {
          height: 60px;
          object-fit: contain;
          margin-bottom: 1rem;
        }
        .sv-choose-card h6 {
          font-family: var(--font-display);
          font-weight: 600;
          font-size: 0.95rem;
          color: #1a1a2e;
          margin-bottom: 0.4rem;
          line-height: 1.3;
        }
        .sv-choose-card p {
          font-family: var(--font-body);
          font-size: 13px;
          font-weight: 400;
          color: #6b7280;
          margin: 0;
          line-height: 1.65;
        }

        /* ── Responsive ── */
        @media (max-width: 1024px) {
          .sv-sol-grid,
          .sv-ben-grid        { grid-template-columns: repeat(2, 1fr); }
          .sv-pillars-grid,
          .sv-choose-grid     { grid-template-columns: repeat(2, 1fr); }
        }
        @media (max-width: 640px) {
          .sv-sol-grid,
          .sv-ben-grid,
          .sv-pillars-grid,
          .sv-choose-grid     { grid-template-columns: 1fr; }
          .sv-why-split       { flex-direction: column; }
          .sv-hero            { height: 260px; }
          .sv-operation-wrap  { padding: 2rem 1rem; }
        }
      `}</style>

      <div className="sv-page">

        {/* ── Hero ── */}
        <header
          className="sv-hero"
          style={{ backgroundImage: `url(${BannerImg})` }}
          aria-label="Our Services"
        >
          <div className="sv-hero-overlay">
            <h1>Our Services</h1>
            <p>
              Empowering businesses with <strong>custom software, AI-driven insights</strong>,
              and <strong>digital transformation solutions</strong>.
            </p>
          </div>
        </header>

        {/* ── Why Us ── */}
        <section className="sv-why-section" aria-label="Why Choose Us">
          <div className="sv-container">
            <div className="sv-why-split">
              <div className="sv-why-img">
                <img
                  src={teamImage}
                  alt={`${COMPANY} team collaborating on client solutions`}
                  loading="lazy"
                />
              </div>
              <div className="sv-why-text">
                <h3>Why Us?</h3>
                <p>
                  Innovations are mere fads until one can use them profitably. Being at the
                  forefront of tech trends, we understand what will bring value to you.
                  We use and test upcoming technologies in our labs before recommending.
                  That is how we have built trust and long-lasting relationships.
                </p>
              </div>
            </div>

            <div className="sv-pillars-grid">
              {WHY_US_PILLARS.map(({ id, icon: Icon, title, desc }) => (
                <div key={id} className="sv-pillar">
                  <Icon size={36} color="#0b355e" aria-hidden="true" />
                  <h6>{title}</h6>
                  <p>{desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── Transport ── */}
        <Transport />

        {/* ── What We Offer intro ── */}
        <div className="sv-offer-intro">
          <h2>What We Offer</h2>
          <hr />
          <p>
            At <strong>{COMPANY}</strong>, we deliver innovative, scalable, and
            future-ready digital solutions. From <strong>cloud SaaS</strong> to{" "}
            <strong>data analytics &amp; automation</strong>, our services are crafted to
            drive efficiency, growth, and digital transformation.
          </p>
        </div>

        {/* ── Application & Software ── */}
        <SolutionSection
          eyebrow="Solutions"
          title="Comprehensive Application & Software Offerings include"
          solutions={APP_SOLUTIONS}
          benefits={APP_BENEFITS}
        />

        {/* ── Networking & Security ── */}
        <SolutionSection
          eyebrow="Solutions"
          title="Comprehensive Networking & Security Offerings include"
          solutions={NET_SOLUTIONS}
          benefits={NET_BENEFITS}
        />

        {/* ── Systems & Infrastructure ── */}
        <SolutionSection
          eyebrow="Solutions"
          title="Comprehensive Systems and Infrastructure Offerings"
          solutions={SYS_SOLUTIONS}
          benefits={SYS_BENEFITS}
          alignStart
        />

        {/* ── Operation ── */}
        <div className="sv-operation-wrap">
          <Operation />
        </div>

        {/* ── Choose Us ── */}
        <section className="sv-choose-section" aria-label={`Why Choose ${COMPANY}`}>
          <div className="sv-container">
            <h3 className="sv-choose-title">
              Why Choose <span style={{ color: "#007bff" }}>Skywise?</span>
            </h3>
            <div className="sv-choose-grid">
              {CHOOSE_US.map(({ id, icon, alt, title, desc }) => (
                <div key={id} className="sv-choose-card">
                  <img src={icon} alt={alt} loading="lazy" />
                  <h6>{title}</h6>
                  <p>{desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <WhatsApp />
      </div>
    </>
  );
}

export default Service;